module.exports = __webpack_public_path__ + "img/delete.ebd24ee0.svg";